import { render } from "./DigitalClockComponent.vue?vue&type=template&id=468df649&scoped=true"
import script from "./DigitalClockComponent.vue?vue&type=script&lang=js"
export * from "./DigitalClockComponent.vue?vue&type=script&lang=js"

import "./DigitalClockComponent.vue?vue&type=style&index=0&id=468df649&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-468df649"]])

export default __exports__